import { Typography } from "antd";

import { FC } from "react";
import { BathroomIcon } from "shared-components/Components/CustomIcons/BathroomIcon";

interface BathroomsTagProps {
	bathrooms: number;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const BathroomsTag: FC<BathroomsTagProps> = ({
	bathrooms,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	return (
		<div className="typology-item-container">
			{isEspecial ? (
				<>
					{icon && <BathroomIcon width={18} />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Baño{bathrooms != 1 ? 's' : ''}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `${bathrooms}+` : bathrooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <BathroomIcon width={18} />}
					<Typography.Text ellipsis>
						{bathrooms}{prefix ? "+" : ""} Baño{bathrooms!=1 ? 's':''}
					</Typography.Text>
				</>
			)}
		</div>
	);
};
